import { Pipe, PipeTransform } from '@angular/core';
import { PerareFeature } from '../../../../shared/services/api/listing-api.types';
import {bearing, bearingToAngle, Polygon, Position} from '@turf/turf';

@Pipe({
  name: 'polygonToSimplifyPolygon',
  standalone: true,
})
export class PolygonToSimplifyPolygonPipe implements PipeTransform {
  transform(value: PerareFeature[], apply: boolean): PerareFeature[] {
    if (!apply) {
      return value;
    }

    return value.map((it) => {
      // Обрабатываем только полигоны
      const geometry = it.geometry as any;
      if (geometry.type !== 'Polygon') {
        return it;
      }
      return {
        geometry: this.simplifyFeature(geometry as Polygon),
        properties: it.properties,
      };
    });
  }

  private simplifyFeature(feature: Polygon): Polygon {
    const dataCopy: Polygon = JSON.parse(JSON.stringify(feature));
    const points: Position[] = dataCopy.coordinates[0];
    let i = 0;
    while (i < points.length - 2) {
      const firstLineStart = points[i];
      const firstLineEnd = points[i + 1];

      const secondLineStart = points[i + 1];
      const secondLineEnd = points[i + 2];

      if (
        this.calculateIsSameAngleBetweenTwoLines(
          firstLineStart,
          firstLineEnd,
          secondLineStart,
          secondLineEnd,
        )
      ) {
        points.splice(i + 1, 1);
      } else {
        i += 1;
      }
    }

    {
      const firstLineStart = points[points.length - 2];
      const firstLineEnd = points[points.length - 1];

      const secondLineStart = points[points.length - 1];
      const secondLineEnd = points[1]; // because points[0] = points[last]

      if (
        this.calculateIsSameAngleBetweenTwoLines(
          firstLineStart,
          firstLineEnd,
          secondLineStart,
          secondLineEnd,
        )
      ) {
        // if we found that points[points.length - 1] is bad for simplification, we need to remove it
        // and set points[points.length - 2]
        const newFirstEndPoint = points[points.length - 2];
        points.splice(points.length - 1, 1);
        points.splice(0, 1);
        points.push(points[0]);
      }
    }

    return dataCopy;
  }

  private calculateIsSameAngleBetweenTwoLines = (
    point1: Position,
    point2: Position,
    point3: Position,
    point4: Position,
  ) => {
    const firstLineAngle = bearingToAngle(bearing(point1, point2));
    const secondLineAngle = bearingToAngle(bearing(point3, point4));

    // https://math.stackexchange.com/questions/3497721/calculate-difference-of-two-numbers-on-the-360-circle
    let diff = Math.abs(firstLineAngle - secondLineAngle);

    if (diff > 180) {
      diff = 360 - diff;
    }

    return diff < 5;
  };
}
